<template>
	<ProcessCreatePage>
		<Header :title="$t('generate_form_assessment_questions').toString()">
			<p>
				{{ $t('fill_out_data_for_damage_assessor_form') }}
			</p>
		</Header>
		<div class="main">
			<div class="mb-6">
				<BaseSelect
					ref="Input.hasRepairedOldDamages"
					:required="true"
					:label="$t('already_repaired_old_damages')"
					:options="yesNoSelect"
					v-model="hasRepairedOldDamages"
					class="w-1/2 pr-6"
				/>

				<BaseInput
					v-if="hasRepairedOldDamages?.value === true"
					v-model="affectedPartsOfOldRepair"
					:label="$t('which_parts_are_affected')"
					ref="BaseInput.affectedParts"
					:required="true"
					class="w-full mt-4"
				>
					<textarea v-model="affectedPartsOfOldRepair" rows="3" class="w-full resize-none" />
				</BaseInput>
			</div>

			<div>
				<BaseSelect
					ref="Input.hasUnrepairedOldDamages"
					:required="true"
					:label="$t('unrepaired_damages_in_new_damage_area')"
					:options="yesNoSelect"
					v-model="hasUnrepairedOldDamages"
					class="w-1/2 pr-6"
				/>

				<BaseInput
					v-if="hasUnrepairedOldDamages?.value === true"
					v-model="affectedPartsOfOldDamage"
					:label="$t('how_does_the_current_damage_look')"
					ref="BaseInput.affectedPartsOfOldDamage"
					:required="true"
					class="w-full mt-4"
				>
					<textarea v-model="affectedPartsOfOldDamage" rows="3" class="w-full resize-none" />
				</BaseInput>
			</div>
			<!--			<div class="mt-8">-->
			<!--				<div class="flex font-bold">-->
			<!--					{{ $t('assessor_create_calculation_via') }}-->
			<!--				</div>-->
			<!--				<BaseRadioForm-->
			<!--					ref="BaseRadioForm.AssessorCalculationOptions"-->
			<!--					:options="assessorCalculationCreationOptions"-->
			<!--					v-model="selectedAssessorCalculationCreationOption"-->
			<!--					class="mt-2"-->
			<!--					:required="true"-->
			<!--					:allow-empty="false"-->
			<!--					error-message="Darf nicht leer sein"-->
			<!--				/>-->
			<!--				<div class="text-left" style="font-style: italic">-->
			<!--					{{ $t('assessor_average_value_on_total_damage_and_manufacturer') }}-->
			<!--				</div>-->
			<!--			</div>-->
			<!--			<div class="mt-8">-->
			<!--				<div class="flex font-bold">-->
			<!--					{{ $t('assessor_perform_tech_investigation') }}-->
			<!--				</div>-->
			<!--				<div class="border-2 border-connectProBlue rounded pl-2 mt-3">-->
			<!--					<BaseCheckbox class="mt-3" ref="BaseCheckbox.errorReadout" :label="$t('vehicle_error_memory_readout')" v-model="errorMemoryReadout" />-->
			<!--					<BaseCheckbox-->
			<!--						ref="BaseCheckbox.thicknessMeasurement"-->
			<!--						:label="$t('layer_thickness_measurement')"-->
			<!--						v-model="layerThicknessMeasurement"-->
			<!--						style="margin-top: -10px"-->
			<!--					/>-->
			<!--					<BaseCheckbox-->
			<!--						ref="BaseCheckbox.residualValue"-->
			<!--						:label="$t('residual_value_determination')"-->
			<!--						v-model="residualValueDetermination"-->
			<!--						style="margin-top: -10px"-->
			<!--					/>-->
			<!--				</div>-->
			<!--			</div>-->
			<!--			<div class="mt-8">-->
			<!--				<BaseCheckbox-->
			<!--					class="border-2 border-connectProBlue rounded p-2"-->
			<!--					ref="BaseCheckbox.assessmentOnSite"-->
			<!--					:label="$t('damage_assessment_on_site_with_travelling')"-->
			<!--					v-model="assessmentOnSite"-->
			<!--				/>-->
			<!--			</div>-->
			<!--			<div class="mt-8">-->
			<!--				<div class="flex font-bold">-->
			<!--					{{ $t('beside_sealed_original_additional_print') }}-->
			<!--				</div>-->
			<!--				<div class="border-2 border-connectProBlue rounded pl-2 mt-3">-->
			<!--					<BaseCheckbox class="mt-3" ref="BaseCheckbox.legalAssistance" :label="$t('legal_assistance')" v-model="documentCopyForLawyer" />-->
			<!--					<BaseCheckbox ref="BaseCheckbox.insurance" :label="$t('insurance')" v-model="documentCopyForInsurance" style="margin-top: -10px" />-->
			<!--					<BaseCheckbox ref="BaseCheckbox.workshop" :label="$t('workshop')" v-model="documentCopyForWorkshop" style="margin-top: -10px" />-->
			<!--					<BaseCheckbox ref="BaseCheckbox.opponent" :label="$t('opponent')" v-model="documentCopyForOpponent" style="margin-top: -10px" />-->
			<!--				</div>-->
			<!--			</div>-->
			<!--			<div class="mt-8">-->
			<!--				<div class="flex font-bold">-->
			<!--					{{ $t('postal_shipping_via') }}-->
			<!--				</div>-->
			<!--				<BaseCheckbox-->
			<!--					class="border-2 border-connectProBlue rounded p-2 mt-3"-->
			<!--					ref="BaseCheckbox.postalOption"-->
			<!--					:label="$t('deutsche_post')"-->
			<!--					v-model="sendWithDeutschePost"-->
			<!--				/>-->
			<!--			</div>-->
		</div>

		<Footer
			@backButtonClick="$emit('previous', $event)"
			@continueButtonClick="continueButtonClick()"
			@skipButtonClick="continueButtonClick(true)"
			:is-back-button="false"
			:is-skippable="false"
		/>
	</ProcessCreatePage>
</template>

<script>
import Footer from '@/components/damagecases/Footer';
import Header from '@/components/damagecases/Header';
import ProcessCreatePage from '@/views/management/Process/ProcessCreatePage';
import BaseSelect from '@/components/forms/inputs/BaseSelect.vue';
import Validate from '@/mixins/Validate';
import { getYesNoOptions } from '@/plugins/Utils';
import BaseInput from '@/components/forms/inputs/BaseInput.vue';
import BaseRadioForm from '@/components/forms/inputs/BaseRadioForm.vue';
import BaseCheckbox from '@/components/forms/inputs/BaseCheckbox.vue';

export default {
	name: 'AssessmentQuestions',
	components: { BaseCheckbox, BaseRadioForm, BaseInput, BaseSelect, ProcessCreatePage, Header, Footer },
	mixins: [Validate],
	props: {
		startValue: {},
		hideBackBtn: { type: Boolean, default: false },
		damageCase: { required: true },
	},
	data() {
		return {
			clientOptions: [],
			selectedClient: null,
			yesNoSelect: getYesNoOptions(),
			hasRepairedOldDamages: null,
			affectedPartsOfOldRepair: '',
			hasUnrepairedOldDamages: null,
			affectedPartsOfOldDamage: '',
			assessorCalculationCreationOptions: [
				{ display: this.$t('manufacturer_contracted_workshop'), value: 'manufacturer_bound_workshop' },
				{ display: this.$t('average_regional_calculation_values_dekra'), value: 'average_calculation_values' },
			],
			selectedAssessorCalculationCreationOption: null,
			technicalInvestigationOptions: [
				{ display: this.$t('vehicle_error_memory_readout'), value: 'error_memory_readout' },
				{ display: this.$t('layer_thickness_measurement'), value: 'layer_thickness_measurement' },
				{ display: this.$t('residual_value_determination'), value: 'residual_value_determination' },
			],
			selectedTechnicalInvestigationOption: null,
			errorMemoryReadout: true,
			layerThicknessMeasurement: true,
			residualValueDetermination: true,
			assessmentOnSite: true,
			documentCopyForLawyer: false,
			documentCopyForInsurance: false,
			documentCopyForWorkshop: true,
			documentCopyForOpponent: false,
			sendWithDeutschePost: true,
		};
	},
	mounted() {
		this.selectedAssessorCalculationCreationOption = this.assessorCalculationCreationOptions[0].value;
	},
	methods: {
		continueButtonClick: function() {
			if (this.validate()) {
				this.$emit('next', {
					assessmentQuestions: {
						has_repaired_old_damages: this.hasRepairedOldDamages.value,
						affected_parts_of_old_damage: this.affectedPartsOfOldRepair ?? null,
						has_unrepaired_old_damages: this.hasUnrepairedOldDamages.value,
						affected_unrepaired_parts_of_old_damage: this.affectedPartsOfOldDamage ?? null,
						error_memory_readout: this.errorMemoryReadout,
						layer_thickness_measurement: this.layerThicknessMeasurement,
						residual_value_determination: this.residualValueDetermination,
						assessment_on_site: this.assessmentOnSite,
						document_copy_lawyer: this.documentCopyForLawyer,
						document_copy_insurance: this.documentCopyForInsurance,
						document_copy_work_shop: this.documentCopyForWorkshop,
						document_copy_opponent: this.documentCopyForOpponent,
						sent_with_deutsche_post: this.sendWithDeutschePost,
						assessor_calculation: this.selectedAssessorCalculationCreationOption,
					},
				});
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
			}
		},
	},
	watch: {
		damageCase(newValue) {
			if (this.damageCase.lawyerOffice && this.damageCase.lawyerOffice?.is_system_partner === 1) {
				this.documentCopyForLawyer = true;
			} else {
				this.documentCopyForInsurance = true;
			}
		},
	},
};
</script>

<style scoped></style>
